import { render, staticRenderFns } from "./AreaUI.vue?vue&type=template&id=27a2e6d5&scoped=true&"
import script from "./AreaUI.vue?vue&type=script&lang=js&"
export * from "./AreaUI.vue?vue&type=script&lang=js&"
import style0 from "./AreaUI.vue?vue&type=style&index=0&id=27a2e6d5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a2e6d5",
  null
  
)

export default component.exports